import {
    PROMOCODE_DELETE_SUCCESS,
    PROMOCODE_DELETE_FAILURE,
    PROMOCODE_DELETE_REQUEST
}
    from '../actions/deletePromoCode'


const setDeletePromoCode = (state = { deleted: false }, action) => {
    switch (action.type) {
        case PROMOCODE_DELETE_SUCCESS:
            return Object.assign({}, action);
        case PROMOCODE_DELETE_FAILURE:
            return Object.assign({}, action);
        case PROMOCODE_DELETE_REQUEST:
            return Object.assign({}, action);
        default:
            return state;
    }
};

export {

    setDeletePromoCode
}